function getElementPositionInDocument(element) {
  const rect = element.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const height = element.offsetHeight;
  return {
    top: rect.top + scrollTop,
    height: height
  };
}

// Fades the fixed desktop TOC out before it reaches the end of the article:
// as soon as its bottom edge would overlap the references (or the end of the
// wrapper if there are none), minus a small buffer.
function updateSidebarVisibilityDesktop() {
  if (window.innerWidth <= 1024) return;
  const sidebar = document.querySelector('.blog-wrapper .blog-sidebar');
  const end =
    document.querySelector('.blog-wrapper .blog-list-reference') ||
    document.querySelector('.blog-wrapper');
  const endTop = end.classList.contains('blog-wrapper')
    ? end.getBoundingClientRect().bottom
    : end.getBoundingClientRect().top;
  const hide = sidebar.getBoundingClientRect().bottom > endTop - 40;
  sidebar.classList.toggle('hide', hide);
}

function loadSideMenuDesktop() {
  const blog = document.querySelector('.blog-wrapper .row');
  const sidebar = document.querySelector('.blog-wrapper .blog-sidebar');
  sidebar.style.marginLeft = blog.offsetWidth + 20 + 'px';

  if (window.innerWidth > 1024) {
    if (window.scrollY >= 125) {
      document.querySelector('.blog-wrapper .blog-sidebar').classList.add('fixed');
      document.querySelector('.blog-wrapper .blog-sidebar').classList.add('top-0');
      document.querySelector('.blog-wrapper .blog-sidebar').classList.remove('absolute');
    }

    updateSidebarVisibilityDesktop();

    if (!document.querySelector('.blog-wrapper .row').classList.contains('mr-[370px]')) {
      document.querySelector('.blog-wrapper .row').classList.add('mr-[370px]');
    }

    window.addEventListener('scroll', function () {
      const element = document.querySelector('.blog-wrapper .blog-sidebar');
      const sidebar = document.querySelector('.blog-wrapper .blog-sidebar');
      const blog = document.querySelector('.blog-wrapper .row');

      if (window.scrollY >= 130) {
        element.classList.add('fixed');
        element.classList.add('top-0');
        element.classList.remove('absolute');
      } else {
        element.classList.add('absolute');
        element.classList.remove('fixed');
        element.classList.remove('top-0');
      }
      updateSidebarVisibilityDesktop();
      if (window.innerWidth > 1024) {
        sidebar.style.marginLeft = blog.offsetWidth + 20 + 'px';
      }
    });
  }
}

function loadSideMenuMobile() {
  if (window.innerWidth > 1024) return;

  const blog = document.querySelector('.blog-wrapper .row');
  const sidebar = document.querySelector('.blog-wrapper > .blog-sidebar');
  if (!blog || !sidebar) return;

  blog.classList.remove('mr-[370px]');
  sidebar.style.marginLeft = '-40px';

  const tocMobile = blog.querySelector('.qlf-toc-main');
  if (!tocMobile) {
    sidebar.classList.remove('show');
    return;
  }
  const positionMobile = getElementPositionInDocument(tocMobile);

  function updateMobileSidebar() {
    if (window.innerWidth > 1024) return;
    sidebar.classList.toggle('show', window.scrollY > positionMobile.top + positionMobile.height);
  }

  updateMobileSidebar();
  window.addEventListener('scroll', updateMobileSidebar);
}

function highlightInToc() {
  document.querySelectorAll('.blog-wrapper .blog-sidebar a').forEach((element) => {
    element.addEventListener('click', function () {
      if (window.innerWidth <= 1024) {
        document.querySelector('.blog-wrapper .blog-sidebar').classList.remove('open');
        document.querySelector('.blog-wrapper > .blog-sidebar .qlf-toc-btn').innerHTML = '+';
      }
    });
  });

  const targetElements = document.querySelectorAll('.blog-wrapper > .row h2');
  const otherElements = document.querySelectorAll('.blog-wrapper .blog-sidebar a');

  targetElements.forEach((targetElement, index) => {
    window.addEventListener('scroll', function () {
      const rect = targetElement.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
      const isVisible2 = rect.bottom <= 0 && rect.top >= window.innerHeight;

      if (isVisible) {
        otherElements.forEach((element) => {
          element.classList.remove('text-dy');
        });
        otherElements[index]?.classList.add('text-dy');
      }

      if (isVisible2) {
        otherElements.forEach((element) => {
          element.classList.remove('text-dy');
        });
        otherElements[index - 1]?.classList.add('text-dy');
      }
    });
  });
}

function openCloseToConMobile() {
  const sidebar = document.querySelector('.blog-wrapper .blog-sidebar');
  document
    .querySelector('.blog-wrapper .blog-sidebar .directory')
    ?.addEventListener('click', function () {
      if (window.innerWidth <= 1024) {
        sidebar.classList.toggle('open');
        if (sidebar.classList.contains('open')) {
          document.querySelector('.blog-wrapper > .blog-sidebar .qlf-toc-btn').innerHTML = 'x';
        } else {
          document.querySelector('.blog-wrapper > .blog-sidebar .qlf-toc-btn').innerHTML = '+';
        }
      }
    });
}

function updateOnResize() {
  window.addEventListener('resize', function () {
    const sidebar = document.querySelector('.blog-wrapper .blog-sidebar');
    const blog = document.querySelector('.blog-wrapper .row');
    if (window.innerWidth > 1024) {
      if (window.scrollY >= 130) {
        sidebar.classList.add('fixed');
        sidebar.classList.add('top-0');
        sidebar.classList.remove('absolute');
      } else {
        sidebar.classList.add('absolute');
        sidebar.classList.remove('fixed');
        sidebar.classList.remove('top-0');
      }
      loadSideMenuDesktop();
    }
    if (window.innerWidth <= 1024) {
      loadSideMenuMobile();
    }
    if (window.innerWidth <= 1283 && window.innerWidth > 1024) {
      sidebar.style.marginLeft = blog.offsetWidth + 20 + 'px';
    }
  });
}

function scrollToElementWithOffset(element, offset = 0) {
  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
  const offsetPosition = elementPosition + offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
}

function showHIdeSidebarDesktopOnOpenArticleReferences() {
  requestAnimationFrame(updateSidebarVisibilityDesktop);
}

document.addEventListener('DOMContentLoaded', function () {
  loadSideMenuDesktop();
  loadSideMenuMobile();
  highlightInToc();
  openCloseToConMobile();
  updateOnResize();
  document.querySelectorAll('.blog-sidebar a').forEach((element) => {
    element.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.getElementById(element.getAttribute('href').replace('#', ''));
      scrollToElementWithOffset(target, 0);
    });
  });
  document.querySelectorAll('.qlf-toc-main a').forEach((element) => {
    element.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.getElementById(element.getAttribute('href').replace('#', ''));
      scrollToElementWithOffset(target, 0);
    });
  });
  document.querySelector('.blog-list-reference > h3')?.addEventListener('click', function () {
    showHIdeSidebarDesktopOnOpenArticleReferences();
  });
});
